export default __webpack_public_path__ + "static/media/businessman-laptop.a2c6ef96.jpg";